import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "retrospect" }

import { ref, watch, onMounted, nextTick } from 'vue'
// import EZUIKit from 'ezuikit-js'


export default /*#__PURE__*/_defineComponent({
  props: {
  imageUrl: {
    type: String,
    default() {
      return ''
    }
  },
  videoUrl: {
    type: String,
    default() {
      return ''
    }
  },
  isPlay: {
    type: Boolean,
    default() {
      return false
    }
  }
},
  emits: ['pause'],
  setup(__props, { emit }) {

const props = __props

onMounted(() => {
  if (isPlay.value) {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(
      (iframe.value as HTMLIFrameElement).contentWindow as Window
    ).location.replace(
      props.videoUrl && props.videoUrl.replace('iframe_se', 'iframe')
    )
  }
  // const player = new EZUIKit.EZUIKitPlayer({
  //   id: 'video-container', // 视频容器ID
  //   // themeId: '511e7a63e7ae4eb59c221b277b85c3a7',
  //   url: 'ezopen://open.ys7.com/F63440787/30.rec?begin=202203281030',
  //   accessToken:
  //     'ra.7byns34o4qrte6tr5oons3d36m5w00e7-64ctgakh0r-0ed6tlc-nbojf3d9f',
  //   template: 'ed5f0dff4f5742c5aff6e9552c167e9f',
  //   width: 1200,
  //   height: 703,
  //   handleError: (...params: any) => {
  //     player.stop()
  //     console.log('uikit error trigger', params)
  //   }
  // })
})



const iframe = ref<null | HTMLIFrameElement>(null)

watch(
  () => props.isPlay,
  (newValue) => {
    isPlay.value = newValue
  }
)

watch(
  () => props.videoUrl,
  (newValue) => {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(
      (iframe.value as HTMLIFrameElement).contentWindow as Window
    ).location.replace(newValue && newValue.replace('iframe_se', 'iframe'))
  }
)

const isPlay = ref(false)
isPlay.value = Boolean(props.isPlay)


const play = () => {
  isPlay.value = true
  nextTick(() => {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(
      (iframe.value as HTMLIFrameElement).contentWindow as Window
    ).location.replace(
      props.videoUrl && props.videoUrl.replace('iframe_se', 'iframe')
    )
  })
}
const pause = () => {
  isPlay.value = false
  emit('pause')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle({
        backgroundImage: `url(${props.imageUrl})`
      }),
      class: "warning-img warning-video"
    }, [
      _createElementVNode("i", {
        class: _normalizeClass([
          'iconfont',
          'iconfont-1',
          !isPlay.value ? 'icon-shexiangtou1' : 'icon-zanting'
        ]),
        onClick: pause
      }, null, 2),
      (!isPlay.value)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "iconfont icon-bofang",
            onClick: play
          }))
        : _createCommentVNode("", true),
      (isPlay.value)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            ref_key: "iframe",
            ref: iframe,
            frameborder: "0",
            width: "100%",
            height: "100%"
          }, null, 512))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})